import styled from 'styled-components';

//documenttablestyle main page
const Documenttablestyle = styled.section`
	// common for table UI start

    .noresult{
        position: relative;
        overflow: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: var(--px-14);
        height: calc(100vh - var(--px-330));
        color: var(--neutrals-700);
        border: var(--px-1) solid var(--neutrals-200);
    }

	.documentwrapper {
		display: grid;
		width: 100%;

		.documentitemview {
			width: 100%;
			display: flex;
			border-collapse: collapse;
			align-items: center;
			justify-content: center;
			border-bottom: var(--px-1) solid var(--neutrals-200);
			height: var(--px-48);

			&.inactive mgt-person {
				color: var(--neutrals-300);
			}


			&:last-child {
				border-bottom: none;
			}
		}

		.document-header {
			width: 100%;
			display: inline-block;
			.documentheader {
				width: 100%;
				color: var(--neutrals-700);
				display: flex;
				border-collapse: collapse;
				background: var(--neutrals-50);
				border: var(--px-1) solid var(--neutrals-200);
				border-radius: var(--px-8) var(--px-8) 0 0;	
				height: var(--px-48);
				border-bottom: none;
			}
		}

		.document-body {
			overflow: auto;
			height: calc(100vh - var(--px-450));
			display: inline-block;
			width: 100%;
			border: var(--px-1) solid var(--neutrals-200);
			background: var(--neutrals-00white);
			border-radius: 0 0 var(--px-8) var(--px-8);
			.documentholder {			
				width: 100%;
				display: inline-block;
				border-bottom: var(--px-1) solid var(--neutrals-200);
			}
		}

		.document-header,
		.document-body {
			.documentitem {
				padding: var(--px-10);
				flex: 1 1 auto;
				width: 20%;
				height: var(--px-48);
				display: flex;
				align-items: center;

				.description {
					display: flex;

					svg.delete {
						cursor: pointer;
					}
				}

				.ellipses {
					display: flex;
				}

                &.uri{
                    width: 30%;
					.ellipses {
						vertical-align: middle;
						line-height: normal;
					}
                }
				
				&.version,
                &.filesize,
                &.fileexist {
					width: 10%;
					.ellipses {
						vertical-align: middle;
						line-height: normal;
					}
				}

                .engname {
					width: 100%;
					display: inline-grid;

					.ellipses {
						line-height: normal;
					}
				}
			}
		}
	}

	// common for table UI end
`;

export default Documenttablestyle;
